var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 2.4439L4.97852 9.09595L22.2662 10.6151L18.9626 3.36117C18.4478 2.23087 17.0627 1.80209 15.9994 2.4439Z",
    fill: "#426306"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31109 23.4024C2.65898 25.378 4.23894 26.9655 6.22227 27.2664C8.19159 27.5652 9.96989 27.8586 12.7011 27.8586C15.4323 27.8586 17.2106 27.5652 19.1799 27.2664C21.1633 26.9655 22.7432 25.378 23.0911 23.4024C23.3595 21.8781 23.6044 20.5544 23.6044 17.9937C23.6044 15.4331 23.3595 14.1094 23.0911 12.5851C22.7432 10.6095 21.1633 9.02197 19.1799 8.72107C17.2106 8.42228 15.4323 8.12891 12.7011 8.12891C9.96989 8.12891 8.1916 8.42228 6.22227 8.72107C4.23894 9.02197 2.65898 10.6095 2.31109 12.5851C2.04267 14.1094 1.79785 15.4331 1.79785 17.9937C1.79785 20.5544 2.04267 21.8781 2.31109 23.4024Z",
    fill: "#426306",
    stroke: "#84C70D",
    strokeWidth: 3.21429
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0589 21.0039H17.8945C16.174 21.0039 14.7793 19.6091 14.7793 17.8887C14.7793 16.1682 16.174 14.7734 17.8945 14.7734H24.0589C25.2424 14.7734 26.2018 15.7328 26.2018 16.9163V18.861C26.2018 20.0445 25.2424 21.0039 24.0589 21.0039Z",
    fill: "#426306",
    stroke: "#84C70D",
    strokeWidth: 3.21429,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97852 9.09595L15.9994 2.4439C17.0627 1.80209 18.4478 2.23087 18.9626 3.36117L22.2662 10.6151",
    stroke: "#84C70D",
    strokeWidth: 3.21429,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositIconActive);
export default __webpack_public_path__ + "static/media/depositIconActive.15cce407124a48d28cab46eb812e34f0.svg";
export { ForwardRef as ReactComponent };